import { DefaultSession, DefaultUser } from "next-auth";
import { DefaultJWT } from "next-auth/jwt";

export enum AuthProvider {
    HaloE = "E",
    HaloB = "B",
}

export interface ProviderMixin {
    provider: AuthProvider;
    groups?: string[];
    ubids?: string[];
    tns?: string[];
}

export interface ExtendedUser extends DefaultUser, ProviderMixin {
    id: string;
}

export interface ExtendedProfile extends ProviderMixin {
    sub: string;
    given_name?: string;
    family_name?: string;
    guid?: string;
}

export interface ExtendedSession extends NonNullable<DefaultSession["user"]>, Pick<DefaultUser, "id">, ProviderMixin {}

export interface ExtendedJWT extends DefaultJWT, ProviderMixin {}
